<template>
	<div class="login">
		<div class="loginBox">
			<div><img src="../assets/img/title.png" width="100%"/></div>
			<div class="input"><el-input size="medium" v-model="loginMsg.usr" placeholder="请输入账号" autofocus></el-input></div>
			<div class="input"><el-input size="medium" type="password" v-model="loginMsg.pwd" placeholder="请输入密码"></el-input></div>
			<div class="input"><el-button size="medium" type="primary" @click="login">登录</el-button></div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
	    return {
	      loginMsg:{}
	    }
	},
	methods: {
	  	login: function(){
	  		this.$http.post("zcvrVideoApi/admin/login",{
	  			usr: this.loginMsg.usr.trim(),
				pwd: this.loginMsg.pwd.trim(),
	  		},{emulateJson:true}).then(
	  			(loginData)=>{
	  				console.log(loginData)
	  				console.log(loginData.body.msg)
	  				if(loginData.body.msg=="ok"){
	  					sessionStorage.setItem("sessionId",loginData.body.data)
	  					sessionStorage.setItem("usrName",this.loginMsg.usr)
	  					this.$router.push({path: '/videoManager',query: ''})
	  				}else{
	  					this.$message.error(loginData.body.msg);
	  				}
	  			},
	  			(error)=>{
	  				this.$message.error("数据连接失败");
	  			}
	  		)
	  	},
	  	//点击enter键时确定登录
		enterBind: function(){
			var vue = this
			document.onkeydown = function (event) {
                var e = event || window.event || arguments.callee.caller.arguments[0];
                if (e && e.keyCode == 13) {
                	if(location.hash=="#/"){
                		vue.login();
                	}
                }
            };
		}
	},
	mounted(){
		this.enterBind()
		sessionStorage.setItem("sessionId",'1b4dedb5-0758-4133-bd79-a2c705f11aac');
	}
}
</script>

<style>
	.login{
		width: 100%;
		height: 100%;
		background: #122B40;
	}
	.loginBox{
		margin: 0 auto;
		position: relative;
		top: 50%;
		width: 230px;
		height: 300px;
		transform: translateY(-60%);
	}
	.loginBox .input{
		margin-bottom: 10px;
	}
	.loginBox .input .el-button--primary{
		margin-top: 5px;
		width: 100%;
		background-color: #337ab7;
    	border-color: #2e6da4;
	}
	.loginBox .input .el-button--primary:hover{
		background-color: #286090;
    	border-color: #286090;
	}
</style>

